import { useRequest } from 'domain/core/hooks/useRequest';

export const useGetDropdownData = (
  dropdownType: string,
  name?: string | null,
  group?: string | null
) => {
  // ✅ Создаем массив параметров
  const queryParams = new URLSearchParams();

  if (name) queryParams.append('name', name);
  if (group) queryParams.append('group', group);

  const url = `/api/v1/dropdowns/${dropdownType}${queryParams.toString() ? `?${queryParams.toString()}` : ''}`;

  const { data, send, isLoading, error, status } = useRequest({
    url,
    sendOnStart: true,
  });

  return { data, send, isLoading, error, status };
};
